<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span class="txit">For Ramsey W. Dulin, Esq., and Caldwell W. Smith, MD,<br/>Friends of My Youth, who were there . . .</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?3b815dab